export const TERMINALS = {
  CTP20P: {
    key: 'CTP20-P',
    name: 'A35',
    prices: {
      purchase: 719,
      shipping: 50,
      secure3ds: 145,
      accessoryLabel: 'סטנד',
      accessoryPrice: 125,
    },
  },
  N6: {
    key: 'N6',
    name: 'Pelecard N6',
    prices: {
      purchase: 790,
      shipping: 50,
      secure3ds: 145,
      accessoryLabel: 'תחנת עגינה לסוללה',
      accessoryPrice: 115,
    },
  },
} as const;
